__turbopack_context__.v({
  "badge": "SecPricing-module-scss-module__YKunJG__badge",
  "badgeLabel": "SecPricing-module-scss-module__YKunJG__badgeLabel",
  "bgImage": "SecPricing-module-scss-module__YKunJG__bgImage",
  "bgImageWrap": "SecPricing-module-scss-module__YKunJG__bgImageWrap",
  "bookmarkIcon": "SecPricing-module-scss-module__YKunJG__bookmarkIcon",
  "card": "SecPricing-module-scss-module__YKunJG__card",
  "cardActive": "SecPricing-module-scss-module__YKunJG__cardActive",
  "cardDimmed": "SecPricing-module-scss-module__YKunJG__cardDimmed",
  "cardHeader": "SecPricing-module-scss-module__YKunJG__cardHeader",
  "cardInner": "SecPricing-module-scss-module__YKunJG__cardInner",
  "cardSlot": "SecPricing-module-scss-module__YKunJG__cardSlot",
  "cardSurface": "SecPricing-module-scss-module__YKunJG__cardSurface",
  "cardTitle": "SecPricing-module-scss-module__YKunJG__cardTitle",
  "cardsArea": "SecPricing-module-scss-module__YKunJG__cardsArea",
  "cardsRow": "SecPricing-module-scss-module__YKunJG__cardsRow",
  "creditsRow": "SecPricing-module-scss-module__YKunJG__creditsRow",
  "ctaLabel": "SecPricing-module-scss-module__YKunJG__ctaLabel",
  "enter": "SecPricing-module-scss-module__YKunJG__enter",
  "exit": "SecPricing-module-scss-module__YKunJG__exit",
  "fade-in": "SecPricing-module-scss-module__YKunJG__fade-in",
  "fade-out": "SecPricing-module-scss-module__YKunJG__fade-out",
  "fade-out-80": "SecPricing-module-scss-module__YKunJG__fade-out-80",
  "featureIcon": "SecPricing-module-scss-module__YKunJG__featureIcon",
  "featureIconWrap": "SecPricing-module-scss-module__YKunJG__featureIconWrap",
  "featureLabel": "SecPricing-module-scss-module__YKunJG__featureLabel",
  "featureRow": "SecPricing-module-scss-module__YKunJG__featureRow",
  "featuresList": "SecPricing-module-scss-module__YKunJG__featuresList",
  "featuresListExpanded": "SecPricing-module-scss-module__YKunJG__featuresListExpanded",
  "headingBlock": "SecPricing-module-scss-module__YKunJG__headingBlock",
  "headingText": "SecPricing-module-scss-module__YKunJG__headingText",
  "outer": "SecPricing-module-scss-module__YKunJG__outer",
  "price": "SecPricing-module-scss-module__YKunJG__price",
  "priceLine": "SecPricing-module-scss-module__YKunJG__priceLine",
  "priceRow": "SecPricing-module-scss-module__YKunJG__priceRow",
  "priceSpacer": "SecPricing-module-scss-module__YKunJG__priceSpacer",
  "priceSuffix": "SecPricing-module-scss-module__YKunJG__priceSuffix",
  "pricing-button-glass": "SecPricing-module-scss-module__YKunJG__pricing-button-glass",
  "pricingCta": "SecPricing-module-scss-module__YKunJG__pricingCta",
  "pricingCtaOverlayGradient": "SecPricing-module-scss-module__YKunJG__pricingCtaOverlayGradient",
  "pricingCtaOverlayPurple": "SecPricing-module-scss-module__YKunJG__pricingCtaOverlayPurple",
  "section": "SecPricing-module-scss-module__YKunJG__section",
  "slide-in-from-bottom": "SecPricing-module-scss-module__YKunJG__slide-in-from-bottom",
  "slide-in-from-left": "SecPricing-module-scss-module__YKunJG__slide-in-from-left",
  "slide-in-from-right": "SecPricing-module-scss-module__YKunJG__slide-in-from-right",
  "slide-in-from-top": "SecPricing-module-scss-module__YKunJG__slide-in-from-top",
  "slide-out-to-bottom": "SecPricing-module-scss-module__YKunJG__slide-out-to-bottom",
  "slide-out-to-left": "SecPricing-module-scss-module__YKunJG__slide-out-to-left",
  "slide-out-to-right": "SecPricing-module-scss-module__YKunJG__slide-out-to-right",
  "slide-out-to-top": "SecPricing-module-scss-module__YKunJG__slide-out-to-top",
  "tagline": "SecPricing-module-scss-module__YKunJG__tagline",
  "zoom-in": "SecPricing-module-scss-module__YKunJG__zoom-in",
  "zoom-out": "SecPricing-module-scss-module__YKunJG__zoom-out",
});
